<form id="proxyEditForm" [formGroup]="proxyEditForm" autocomplete="off">
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label for="firstname" class="control-label" [ngClass]="{'required': isAdd}">{{
        'i18n.base.user-add-modal.proxyName' | translate }}</label>
      <input id="firstname" name="firstname" type="text" autocomplete="off" class="form-control" formControlName="firstname" />
      <app-error-messages [control]="proxyEditForm.controls.firstname"></app-error-messages>
    </div>
    <div class="form-group col-md-6">
      <label for="password" class="control-label" [ngClass]="{'required': isAdd}">{{ "i18n.shared.fields.new-password" |
        translate }}</label>
      <app-password-input inputId="password"
                          name="password"
                          autocomplete="new-password"
                          formControlName="password">
      </app-password-input>
      <app-error-messages [control]="proxyEditForm.controls.password"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-12">
      <label for="userName" class="control-label">{{ 'i18n.base.user-add-modal.userName' | translate }}</label>
      <input id="userName" name="userName" type="text" autocomplete="off" class="form-control" formControlName="userName" />
      <app-error-messages [control]="proxyEditForm.controls.userName"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    @if (!hideClient()) {
      <div class="form-group col-md-12">
        <label class="control-label" [ngClass]="{'required': isAdd}">{{
          'i18n.base.user-management.column-headers.client' | translate }}</label>
        <app-client-autocomplete class="client-autocomplete" formControlName="client"
          placeholder=""></app-client-autocomplete>
      </div>
    }
  </div>
  @if (!isAdd && !isLoggedInUser) {
    <div class="form-row row">
      <div class="form-group col-md-12">
        <label class="d-block">{{ 'i18n.base.user-add-modal.enabled' | translate }}</label>
        <app-yes-no-group-button id="enabled" formControlName="enabled"></app-yes-no-group-button>
      </div>
    </div>
  }
</form>
